import { LinkableEntityType } from '@api';
import { Anchor } from '@common';

type CompanyAnchorPropsType = { company: LinkableEntityType };

export const CompanyAnchor: React.FC<CompanyAnchorPropsType> = ({
  company,
}) => {
  return (
    <Anchor key={company.id} to={`/companies/$id`} params={{ id: company.id }}>
      {company.name}
    </Anchor>
  );
};
